import { START_SLOT_DATE } from "models/constant";
import { timeByTimestamp } from './time';

export const getSlotStartTime = (slot: string): string => {
    const timestamp = START_SLOT_DATE + parseFloat(slot) * 12;
    return timeByTimestamp(timestamp);
};
